import { NavLink, useNavigate } from 'react-router-dom'
import { Container, Nav, Navbar, Button } from 'react-bootstrap'
import { useAuth } from '../contexts/AuthContext'

function Layout({ children }) {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <div className="sidebar d-flex flex-column">
        <div className="p-3 text-white">
          <h5 className="mb-0">Picchu AI</h5>
          <small className="text-muted">Administration</small>
        </div>

        <Nav className="flex-column px-2">
          <Nav.Link as={NavLink} to="/dashboard" className="nav-link">
            📊 Dashboard
          </Nav.Link>
          <Nav.Link as={NavLink} to="/compare" className="nav-link">
            🔀 Comparaison
          </Nav.Link>
          <Nav.Link as={NavLink} to="/files" className="nav-link">
            📁 Fichiers
          </Nav.Link>
          <Nav.Link as={NavLink} to="/memory" className="nav-link">
            🧠 Mémoire
          </Nav.Link>
          <Nav.Link as={NavLink} to="/projects" className="nav-link">
            📂 Projets
          </Nav.Link>
          <Nav.Link as={NavLink} to="/models" className="nav-link">
            🤖 Modèles
          </Nav.Link>
          <Nav.Link as={NavLink} to="/novita" className="nav-link">
            🖥️ Novita
          </Nav.Link>
          <Nav.Link as={NavLink} to="/usage" className="nav-link">
            📈 Usage
          </Nav.Link>
          <Nav.Link as={NavLink} to="/costs" className="nav-link">
            💰 Coûts
          </Nav.Link>
          <Nav.Link as={NavLink} to="/promo-codes" className="nav-link">
            🎟️ Codes promo
          </Nav.Link>
          <Nav.Link as={NavLink} to="/gemini-accounts" className="nav-link">
            🤖 Comptes Gemini
          </Nav.Link>
          <Nav.Link as={NavLink} to="/chatgpt-accounts" className="nav-link">
            🤖 Comptes ChatGPT
          </Nav.Link>
          <Nav.Link as={NavLink} to="/claude-accounts" className="nav-link">
            🤖 Comptes Claude
          </Nav.Link>
          <Nav.Link as={NavLink} to="/creators" className="nav-link">
            👥 Créateurs
          </Nav.Link>
          <Nav.Link as={NavLink} to="/users" className="nav-link">
            👤 Utilisateurs
          </Nav.Link>
          <Nav.Link as={NavLink} to="/logs" className="nav-link">
            📝 Logs
          </Nav.Link>
          <div className="px-3 py-2 text-muted small">
            <strong>Mailing</strong>
          </div>
          <Nav.Link as={NavLink} to="/mailing/templates" className="nav-link">
            📧 Templates Email
          </Nav.Link>
          <Nav.Link as={NavLink} to="/mailing/newsletter" className="nav-link">
            📰 Newsletter
          </Nav.Link>
          <Nav.Link as={NavLink} to="/mailing/logs" className="nav-link">
            📬 Logs Email
          </Nav.Link>
          <div className="px-3 py-2 text-muted small">
            <strong>Sondages</strong>
          </div>
          <Nav.Link as={NavLink} to="/polls" className="nav-link">
            📊 Sondages
          </Nav.Link>
          <div className="px-3 py-2 text-muted small">
            <strong>Hugging Face</strong>
          </div>
          <Nav.Link as={NavLink} to="/hf-models" className="nav-link">
            🤗 Modèles HF
          </Nav.Link>
          <Nav.Link as={NavLink} to="/settings/routing" className="nav-link">
            ⚙️ Routage
          </Nav.Link>
        </Nav>

        <div className="mt-auto p-3 border-top border-secondary">
          <div className="text-white small mb-2">{user?.email}</div>
          <Button variant="outline-light" size="sm" onClick={handleLogout}>
            Déconnexion
          </Button>
        </div>
      </div>

      {/* Main content */}
      <div className="main-content flex-grow-1">
        <Navbar bg="white" className="border-bottom px-4">
          <Container fluid>
            <Navbar.Text className="text-dark">
              Bienvenue, {user?.first_name || 'Admin'}
            </Navbar.Text>
          </Container>
        </Navbar>

        <Container fluid className="p-4">
          {children}
        </Container>
      </div>
    </div>
  )
}

export default Layout
